import refOffresJson from '../../../data/offre'

import React from "react"
import { getPertinenceColor } from '../Tab1/ListUser'

function Offer({ offre }) {
  var theOF = refOffresJson.find(refoffre => refoffre.id === offre.id);

  return (
    <div className=" ">
      <div className="row ">
        <div className="col s10">
          <p className="card-title">{theOF.title}</p>
          <p>{theOF.description}</p>
          <blockquote>{offre.texte}</blockquote>
        </div>
        <div className="col s2 ">
          <p className="card-title center-align"><span
            className={getPertinenceColor(offre.pertinence)}>{offre.pertinence}%</span></p>

        </div>
      </div>
      <hr/>

    </div>

  )
}

export default Offer